import React, { VFC } from 'react'
import styled from 'styled-components'

import { ImageV2 } from '@Components/Image'
import {
  SliderProps,
} from '@Components/Slider/components/sliders/Slider.interface'

const StyledWrapper = styled.div`
  position: relative;
  height: 100%;
`

const Center = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background: rgb(0,0,0,0.3);
  padding: 4px;

  span {
    font-size: .7em;
    margin-top: -1.5em
  }

  svg {
    height: 75%;
    margin-bottom: 3px;
  }

  svg path, span {
    color: #fff;
  }
`

export const ThumbnailSlide: VFC<SliderProps> = ({ alt, source }) => (
  <StyledWrapper>
    <ImageV2 alt={alt} draggable={false} height={85} src={source} width={85} />
    <Center>
      <svg aria-hidden="true" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5.14v14l11-7l-11-7Z" fill="currentColor" />
      </svg>
      <span>VIDEO</span>
    </Center>
  </StyledWrapper>
)
